webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);



var config = {
  apiKey: 'AIzaSyCtYWfZSjmmZ0jindNHz6GBJl3rDK1XCF8',
  authDomain: 'xinc-5cf8d.firebaseapp.com',
  databaseURL: 'https://xinc-5cf8d.firebaseio.com',
  storageBucket: 'xinc-5cf8d.appspot.com',
  messagingSenderId: '778786654543'
};

__WEBPACK_IMPORTED_MODULE_1_firebase__["initializeApp"](config);

var initializeAuth = function initializeAuth() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().onAuthStateChanged(function (user) {
      authService.setUser(user);
      authService.loaded = true;
      resolve(user);
    });
  });
};

var authService = {

  firebase: __WEBPACK_IMPORTED_MODULE_1_firebase__,
  loaded: false,
  user: null,

  authenticated: function authenticated() {
    return this.loaded && this.user !== null && !this.user.isAnonymous;
  },
  isLoaded: function isLoaded() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      initializeAuth().then(function (user) {
        resolve(user);
      });
    });
  },
  getToken: function getToken() {
    if (this.loaded) {
      return this.user.getToken();
    } else {
      return null;
    }
  },
  setUser: function setUser(user) {
    this.user = user;
    if (user !== null) {
      this.loaded = true;
    } else {
      this.loaded = false;
    }
  },
  login: function login(email, password) {
    return this.firebase.auth().signInWithEmailAndPassword(email, password);
  },
  logout: function logout() {
    this.firebase.auth().signOut().then(function () {
      console.log('logout finished');
    });
  }
};

initializeAuth();

/* harmony default export */ __webpack_exports__["a"] = authService;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {};
config.debug = false;

if (true) {
  config.base_url = 'https://api.xinc.io';
} else {
  config.debug = true;
  config.base_url = 'http://localhost:5000';
}

/* harmony default export */ __webpack_exports__["a"] = config;

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Projects__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Create__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProjectDetail__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProjectDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProjectDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__(3);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Projects___default.a,
    beforeEnter: loginRequired
  }, {
    path: '/projects/:id',
    name: 'ProjectDetail',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ProjectDetail___default.a,
    beforeEnter: loginRequired,
    props: true
  }, {
    path: '/create',
    name: 'CreateProject',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Create___default.a,
    beforeEnter: loginRequired
  }]
});

function loginRequired(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].authenticated()) {
    next();
  } else {
    __WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].isLoaded().then(function (user) {
      if (__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].authenticated()) {
        next();
      } else {
        next('login');
      }
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = router;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  data: function data() {
    return {
      auth: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */]
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue___default.a
  }
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'create',
  data: function data() {
    return {
      project: {
        role: '',
        title: '',
        recipient: '',
        message: '',
        user: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].user.uid
      }
    };
  },

  methods: {
    submitProject: function submitProject() {
      var _this = this;

      console.log(this.project);
      __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].user.getToken().then(function (token) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].base_url + '/projects', _this.project, { headers: { 'Authorization': token } }).then(function (resp) {
          _this.$router.push('/projects/' + resp.data.projects.id);
        }).catch(function (errors) {
          console.log(errors);
        });
      });
    }
  }
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'home',
  data: function data() {
    return {
      auth: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */],
      msg: 'Welcome to xInc!'
    };
  }
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'loading'
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      'auth': __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */],
      'user': {
        'email': '',
        'password': ''
      },
      'error_message': null
    };
  },

  methods: {
    loginUser: function loginUser(e) {
      var _this = this;

      this.auth.login(this.user.email, this.user.password).then(function (res) {
        _this.error_message = null;
        _this.$router.push('/');
      }).catch(function (error) {
        _this.error_message = error.message;
      });
    },
    logoutUser: function logoutUser(e) {
      console.log('logging out');
      this.auth.logout();
      this.user.email = '';
      this.user.password = '';
    }
  }
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["default"] = {
  props: ['id'],
  data: function data() {
    return {
      project: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getToken().then(function (token) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].base_url + '/projects/' + _this.id, { headers: { 'Authorization': token } }).then(function (res) {
        _this.project = res.data.projects;
      });
    });
  }
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loading_vue__);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'projects',
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getToken().then(function (token) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].base_url + '/projects', { headers: { 'Authorization': token } }).then(function (res) {
        _this.client_projects = res.data.projects.filter(function (project) {
          return project.role === 'client';
        });
        _this.contractor_projects = res.data.projects.filter(function (project) {
          return project.role === 'contractor';
        });
      });
    });
  },
  data: function data() {
    return {
      auth: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */],
      shown: 'client',
      client_projects: [],
      contractor_projects: []
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__Loading_vue___default.a
  }
};

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.6759480.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-3e1aa8b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-2299b399",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-4e81a61f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  "data-v-49a97900",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-3e89f0b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.auth.authenticated() ? 'logout' : 'login'))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("projects")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/create"
    }
  }, [_vm._v("create project")])], 1)
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Create a new xinc project here!  \n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitProject($event)
      }
    }
  }, [_c('p', [_vm._v("Your Role:")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.role),
      expression: "project.role"
    }],
    attrs: {
      "type": "radio",
      "id": "project_role_client",
      "value": "client"
    },
    domProps: {
      "checked": _vm._q(_vm.project.role, "client")
    },
    on: {
      "__c": function($event) {
        _vm.project.role = "client"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "project_role_client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.role),
      expression: "project.role"
    }],
    attrs: {
      "type": "radio",
      "id": "project_role_contractor",
      "value": "contractor"
    },
    domProps: {
      "checked": _vm._q(_vm.project.role, "contractor")
    },
    on: {
      "__c": function($event) {
        _vm.project.role = "contractor"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "project_role_contractor"
    }
  }, [_vm._v("Contractor")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "project_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.title),
      expression: "project.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project_title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.project.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "project_recipient"
    }
  }, [_vm._v("Recipient")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.recipient),
      expression: "project.recipient"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project_recipient ",
      "type": "email"
    },
    domProps: {
      "value": (_vm.project.recipient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.recipient = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.message),
      expression: "project.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.project.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("submit")])])])
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.shown = 'client'
      }
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.shown = 'contractor'
      }
    }
  }, [_vm._v("Contractor")]), _vm._v(" "), (_vm.shown == 'contractor') ? _c('div', [_c('h3', [_vm._v("Contractor Projects")]), _vm._v(" "), _vm._l((_vm.contractor_projects), function(project) {
    return _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: 'projects/' + project.id
        }
      }
    }, [_vm._v(_vm._s(project.title))])], 1)
  }), _vm._v(" "), (_vm.contractor_projects.length == 0) ? _c('div', [_c('loading')], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.shown == 'client') ? _c('div', [_c('h3', [_vm._v("Client Projects")]), _vm._v(" "), _vm._l((_vm.client_projects), function(project) {
    return _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: 'projects/' + project.id
        }
      }
    }, [_vm._v(_vm._s(project.title))])], 1)
  }), _vm._v(" "), (_vm.client_projects.length == 0) ? _c('div', [_c('loading')], 1) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project !== null) ? _c('div', {
    staticClass: "project-detail"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('p', [_vm._v("Project ID " + _vm._s(_vm.id))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.recipient))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "project-message"
    }
  }, [_vm._v(_vm._s(_vm.project.message))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.created))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.auth !== null && _vm.auth.user !== null) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logoutUser($event)
      }
    }
  }, [_vm._v("Logout")])]) : _c('div', [(_vm.error_message !== null) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("login")])])])])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo-container"
    }
  }, [(_vm.auth.user !== null) ? _c('p', [_vm._v("Logged in with " + _vm._s(_vm.auth.user.email))]) : _c('p', [_vm._v("not logged in")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.auth.loaded) ? _c('div', [_c('router-view')], 1) : _c('div', [_c('loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": __webpack_require__(119)
    }
  })])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-spinner"
  }, [_c('div', {
    staticClass: "loading-spinner-inner"
  }, [_c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")]), _vm._v(" "), _c('label', [_vm._v("\t●")])])])
}]}

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(3);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  created: function created() {
    this.firebase = __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */];
  }
});

/***/ })
],[134]);


// WEBPACK FOOTER //
// static/js/app.c29ef042d8dbfa8da6eb.js